module.exports = __webpack_public_path__ + "media/application/images/svgs/tool-53222b5e06a45dd7843a0460216acb07.svg";